import ownersService from "@/services/ownersService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      const res = await ownersService.create(formData);
      dispatch("findAll");
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await ownersService.findAll();
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAllWithSettlementStatistic({ dispatch }, formData) {
    try {
      const res = await ownersService.findAllWithSettlementStatistic(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer für Abrechnung konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async search({ dispatch }, payload) {
    try {
      const res = await ownersService.search(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await ownersService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAllSettlements({ dispatch }, { id }) {
    try {
      const res = await ownersService.findAllSettlements({ id });
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Abrechnungen konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await ownersService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      const res = await ownersService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Eigentümer wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async statistics({ dispatch }, formData) {
    try {
      const res = await ownersService.statistics(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Eigentümer Statistik konnte nicht geladen werden.",
        { root: true }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
